import client from "../../../api/client";

export default async function deleteRoomListing(listingId) {
    const response = await client.delete(`/room-listings/${listingId}`);
    return response.data;
}